import { render, staticRenderFns } from "./AktarDetayUstBasliklar.vue?vue&type=template&id=176ed096&scoped=true"
import script from "./AktarDetayUstBasliklar.vue?vue&type=script&lang=ts"
export * from "./AktarDetayUstBasliklar.vue?vue&type=script&lang=ts"
import style0 from "./AktarDetayUstBasliklar.vue?vue&type=style&index=0&id=176ed096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176ed096",
  null
  
)

export default component.exports